<div class="select-popup" (clickOutside)="onClickOutside()" [delayClickOutsideInit]="true">
  <div class="select-popup__items">
    @for (option of options(); track option.value) {
      <div
        class="select-popup__item"
        [class.select-popup__item_active]="option.value === selectedValue()"
        (click)="onSelect(option)"
      >
        <div class="select-popup__underline">
          <div class="select-popup__text">{{ option.label }}</div>
          <div class="select-popup__check">
            <svg width="12px" height="10px" viewBox="0 0 12 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.00933,0.446917 C8.0451,3.144225 6.08006,5.841533 4.11583,8.538455 C4.41606,8.371607 4.7159,8.20476 5.01614,8.037527 C5.70279,8.033288 5.82987,8.468711 5.17698,7.835614 C4.69684,7.36975 4.2167,6.903501 3.73656,6.437638 C3.08486,5.805312 2.43356,5.172986 1.78186,4.54066 C0.83032,3.61741 -0.64385,5.047753 0.30729,5.971389 C1.43953,7.069578 2.57097,8.167768 3.70281,9.265958 C4.5213,10.060122 5.31121,10.390735 6.0896,9.322216 C7.99625,6.704286 9.9033,4.086356 11.80955,1.468426 C12.58794,0.399907 10.77859,-0.608887 10.00933,0.446917"
                fill="#3CD2C8"
                fill-rule="nonzero"
              ></path>
            </svg>
          </div>
        </div>
      </div>
    }
  </div>
</div>
